import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useSystemStateHooks } from '../../system'
import { SaleOperation } from '../state/types'
import { useHoardLoaders } from './hoardLoaders'
import { useSaleLoaders } from './saleLoaders'

export const useSaleOperationLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const saleLoaders = useSaleLoaders()
    const hoardLoaders = useHoardLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadSaleOperation = (
            table: TableName,
            id: string,
            dbRequest = false
        ) => {
            const { loadSale } = saleLoaders(companyId)
            const { loadHoard } = hoardLoaders(companyId)
            const loadOperation = table === TableName.SALE_ORDERS ? loadSale : loadHoard
            return loadOperation(id, dbRequest) as Promise<O<SaleOperation>>
        }

        const loadSaleOperations = async (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadSales } = saleLoaders(companyId)
            const { loadHoards } = hoardLoaders(companyId)
            const sales = await loadSales(ids, dbRequest)
            const hoards = await loadHoards(ids, dbRequest)
            return [...sales, ...hoards] as SaleOperation[]
        }

        const loadSaleOperationsWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadSalesWithProp } = saleLoaders(companyId)
            const { loadHoardsWithProp } = hoardLoaders(companyId)
            const sales = await loadSalesWithProp(propName, dbRequest)
            const hoards = await loadHoardsWithProp(propName, dbRequest)
            return [...sales, ...hoards] as SaleOperation[]
        }

        const countSaleOperations = async (propName: string, propValue: string) => {
            const { countSales } = saleLoaders(companyId)
            const { countHoards } = hoardLoaders(companyId)
            const salesCount = await countSales(propName, propValue)
            const hoardsCount = await countHoards(propName, propValue)
            return salesCount + hoardsCount
        }

        return {
            loadSaleOperation,
            loadSaleOperations,
            loadSaleOperationsWithProp,
            countSaleOperations
        }
    }
}
